import React, { useState, useEffect, MouseEvent } from 'react';
import Link from 'next/link';
import Icon from '../atoms/Icon';
import clsx from 'clsx';
import styles from '../../styles/components/molecules/TeaserBox.module.scss';

interface TeaserBoxProps {
  className?: string;
  icon: string;
  href?: string;
  onClick?: () => void;
  even?: boolean;
  active?: boolean;
  shadow?: boolean;
  square?: boolean;
  caption?: string;
  title?: string;
  half?: boolean;
  full?: boolean;
  disabled?: boolean;
}

export default function TeaserBox(props: TeaserBoxProps) {
  const { teaserbox } = styles;
  const {
    icon,
    title,
    caption,
    href,
    half,
    full,
    disabled,
    active,
    shadow,
    square,
    even,
    onClick,
    className,
  } = props;
  const classes = clsx(
    teaserbox,
    { [styles.shadow]: shadow },
    { [styles.even]: even },
    { [styles.noTitle]: !title },
    { [styles.square]: square },
    { [styles.active]: active },
    { [styles.clickable]: !!onClick || !!href },
    { [styles.half]: half && !full },
    { [styles.full]: full && !half },
    { [styles.disabled]: disabled },
    className
  );

  const currFigure = (
    <figure>
      <Icon name={icon} />
      <figcaption>
        {!!title && <small>{title}</small>}
        <br />
        {!!caption && <small>{caption}</small>}
      </figcaption>
    </figure>
  );

  return (
    <div className={classes} onClick={href ? undefined : onClick}>
      {!!href ? (
        <Link href={href}>
          <a>{currFigure}</a>
        </Link>
      ) : (
        currFigure
      )}
    </div>
  );
}
